// Heartbeat service: keeps the operator marked as online while the session is alive.
// The backend expects a POST /api/v1/auth/heartbeat at least every 180 seconds.

import axios from '@/api/axios'
import { getAccessToken } from '@/api/axios'

const HEARTBEAT_INTERVAL_MS = 60_000

let intervalId: ReturnType<typeof setInterval> | null = null
let isRunning = false

export function startHeartbeat(): () => void {
  if (isRunning) {
    return stopHeartbeat
  }

  isRunning = true

  // Send an initial heartbeat immediately when starting.
  sendHeartbeat().catch(() => {
    // Backend tolerates silent failures; we intentionally swallow errors.
  })

  intervalId = setInterval(() => {
    const token = getAccessToken()
    if (!token) {
      stopHeartbeat()
      return
    }

    sendHeartbeat().catch(() => {
      // Fire-and-forget; the backend job will mark offline if heartbeats stop.
    })
  }, HEARTBEAT_INTERVAL_MS)

  return stopHeartbeat
}

export function stopHeartbeat(): void {
  if (intervalId !== null) {
    clearInterval(intervalId)
    intervalId = null
  }
  isRunning = false
}

export async function sendHeartbeat(): Promise<void> {
  const token = getAccessToken()
  if (!token) {
    return
  }
  await axios.post('/api/v1/auth/heartbeat')
}
